<app-so-select [label]="label" [data]="users" [loading]="showLoadingIcon"
[required]="required"></app-so-select>
